import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface ContentSectionHeaderProps {
  label: string;
  count?: ReactNode;
  barColor?: string;
  className?: string;
}

export const ContentSectionHeader = ({
  label,
  count,
  barColor,
  className,
}: ContentSectionHeaderProps) => (
  <div className={cn('flex items-center gap-2.5 px-1', className)}>
    {barColor && (
      <span
        aria-hidden="true"
        className="h-3.5 w-[3px] shrink-0 rounded-full"
        style={{ background: barColor }}
      />
    )}
    <h3
      className="font-heading uppercase tracking-wider text-slate-500"
      style={{ margin: 0, fontSize: '12px', fontWeight: 800, lineHeight: 1 }}
    >
      {label}
    </h3>
    {count != null && (
      <span className="ml-auto rounded-full bg-[#eef1f6] px-2.5 py-0.5 text-[11px] font-extrabold text-slate-400">
        {count}
      </span>
    )}
  </div>
);
